import React from 'react'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Button, Card, Col, Form, Input, Popover, Radio, Row, Select, Space, Typography } from 'antd'
import PropTypes from 'prop-types'
import InputMask from 'react-input-mask'
import { EmptyHeaderHero } from './components'

import AddVehicleStyle from '../../styles/AddVehicle.module.css'

import {
  COLLISION_COVERAGE_DAMAGE_MI,
  COLLISION_TYPE,
  OTHER_THAN_COLLISION_COVERAGE_MI,
  RENTAL_REIMBURSEMENT_MI,
  VEHICLE_COLLISION_DEDUCTIBLE,
  VEHICLE_COLLISION_MI,
  VEHICLE_COLLISION_TYPE,
  VEHICLE_MILEGE,
  VEHICLE_OWNERSHIP,
  VEHICLE_USAGE
} from './AddVehicleConstants'

const { Text } = Typography
const { Option } = Select
const { TextArea } = Input

const AddVehicleMI = ({ miVehicle, setMIVehicle, handleSubmit, validate }) => {

  const updateUserTextFields = (text, field) => {
    const clonedVehicle = { ...miVehicle }
    clonedVehicle[field] = text
    setMIVehicle(clonedVehicle)
  }
  
  return (
    <>
      <EmptyHeaderHero minHeight={true} title="Add Vehicle - Michigan" />
      <div className={`${AddVehicleStyle["add-vehicle"]}`}>
        <p className={`${AddVehicleStyle["disclaimer"]}`}>Once your change request has been approved and processed, you will be sent updated policy documents and billing schedule.</p>
        <Row>
          <Card className={`${AddVehicleStyle["register-card"]}`}>
            <h5 className={`${AddVehicleStyle["sub-label"]}`}>Policyholder Information</h5>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "firstName") }}
                    placeholder="First Name*"
                    value={miVehicle.firstName}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "lastName") }}
                    placeholder="Last Name*"
                    value={miVehicle.lastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "policyNumber") }}
                    placeholder="Policy Number*"
                    value={miVehicle.policyNumber}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["input-text"]} ${AddVehicleStyle["phone-number"]}`}
                    mask="(999) 999-9999"
                    onChange={event => { updateUserTextFields(event.target.value, "phoneNumber") }}
                    placeholder="Phone Number*"
                    value={miVehicle.phoneNumber}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      setMIVehicle({
                        ...miVehicle,
                        streetAddress: event.target.value
                      })
                    }}
                    placeholder="Street Address*"
                    value={miVehicle.streetAddress}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    maxLength={5}
                    onChange={event => {
                      setMIVehicle({
                        ...miVehicle,
                        zipCode: event.target.value.replace(/\D/g, '')
                      })
                    }}
                    placeholder="Zip Code*"
                    value={miVehicle.zipCode}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => { updateUserTextFields(event.target.value, "emailAddress") }}
                    placeholder="Email Address*"
                    value={miVehicle.emailAddress}
                  />
                </Form.Item>
              </Col>
            </Row>
            <h5 className={`${AddVehicleStyle["sub-label"]}`}>Vehicle Information</h5>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.vin = event.target.value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="VIN*"
                    value={miVehicle.vehicleInfo.vin}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 7 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.year = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Year*"
                        value={miVehicle.vehicleInfo.year}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 7, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.make = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Make*"
                        value={miVehicle.vehicleInfo.make}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.model = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Model*"
                        value={miVehicle.vehicleInfo.model}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.stateRegistered = event.target.value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="State Vehicle will be Registered*"
                    value={miVehicle.vehicleInfo.stateRegistered}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.purchaseDate = event.target.value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Date Vehicle Purchased (mm/dd/yyyy)*"
                    value={miVehicle.vehicleInfo.purchaseDate}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>In whose name will the vehicle be registered?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.registeredPersonFirstName = event.target.value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="First Name*"
                    value={miVehicle.vehicleInfo.registeredPersonFirstName}
                  />
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Input
                    autoComplete="off"
                    className={`${AddVehicleStyle["input-text"]}`}
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.registeredPersonLastName = event.target.value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Last Name*"
                    value={miVehicle.vehicleInfo.registeredPersonLastName}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>How will the vehicle be used?*</Text>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={value => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.vehicleUsage = value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={miVehicle.vehicleInfo.vehicleUsage}
                  >
                    {VEHICLE_USAGE.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Estimated annual mileage?*</Text>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.annualMileage = event
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={miVehicle.vehicleInfo.annualMileage}
                  >
                    {VEHICLE_MILEGE.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is this vehicle owned, leased, or financed?*</Text>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <Select
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.vehicleOwnership = event
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    placeholder="Select from the following"
                    value={miVehicle.vehicleInfo.vehicleOwnership}
                  >
                    {VEHICLE_OWNERSHIP.map((item, index) => (
                      <Option key={index} value={item.label}>
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            {(miVehicle.vehicleInfo.vehicleOwnership === 'Leased' ||
              miVehicle.vehicleInfo.vehicleOwnership === 'Financed') && (
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.nameOfBank = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Name of Bank/Leasing Company*"
                        value={miVehicle.vehicleInfo.nameOfBank}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is there a Co-Owner/Co-Buyer/Co-Lessee?*</Text>
                <Radio.Group
                  className={`${AddVehicleStyle["row-margin-bottom-8"]}`}
                  onChange={event => {
                    const vehicleInfo = { ...miVehicle.vehicleInfo }
                    vehicleInfo.isVehicleWithCoOwnership = event.target.value
                    setMIVehicle({
                      ...miVehicle,
                      vehicleInfo
                    })
                  }}
                  value={miVehicle.vehicleInfo.isVehicleWithCoOwnership}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {miVehicle.vehicleInfo.isVehicleWithCoOwnership === 'Yes' && (
              <>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.coOwnershipPersonFirstName = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="First Name*"
                        value={miVehicle.vehicleInfo.coOwnershipPersonFirstName}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.coOwnershipPersonLastName = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Last Name*"
                        value={miVehicle.vehicleInfo.coOwnershipPersonLastName}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Row>
              <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Do you choose “Other than Collision” (Comprehensive) coverage?*</Text>
              <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{OTHER_THAN_COLLISION_COVERAGE_MI}</p>} title={null}>
                <InfoCircleOutlined />
              </Popover>
            </Row>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  className={`${AddVehicleStyle["row-margin-bottom-8"]}`}
                  onChange={event => {
                    const vehicleInfo = { ...miVehicle.vehicleInfo }
                    vehicleInfo.otherCollisionCoverage = event.target.value
                    setMIVehicle({
                      ...miVehicle,
                      vehicleInfo
                    })
                  }}
                  value={miVehicle.vehicleInfo.otherCollisionCoverage}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {miVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
                  Choose your “Other than Collision” (Comprehensive) deductible.*
                </Text>
                <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Select
                      onChange={event => {
                        const vehicleInfo = { ...miVehicle.vehicleInfo }
                        vehicleInfo.otherCollisionDeductible = event
                        setMIVehicle({
                          ...miVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Select from the following"
                      value={miVehicle.vehicleInfo.otherCollisionDeductible}
                    >
                      {VEHICLE_COLLISION_MI.map((item, index) => (
                        <Option key={index} value={item.label}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </>
            )}
            {miVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Row>
                    <Text className={`${AddVehicleStyle["form-effect-label"]}`}>
                      Do you choose “Collision” coverage?*
                      <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{COLLISION_COVERAGE_DAMAGE_MI}</p>} title={null}>
                        <InfoCircleOutlined />
                      </Popover>
                    </Text>
                  </Row>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Radio.Group
                      onChange={event => {
                        const vehicleInfo = { ...miVehicle.vehicleInfo }
                        vehicleInfo.collisionCoverage = event.target.value
                        setMIVehicle({
                          ...miVehicle,
                          vehicleInfo
                        })
                      }}
                      value={miVehicle.vehicleInfo.collisionCoverage}
                    >
                      <Radio value="Yes">Yes</Radio>
                      <Radio value="No">No</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {miVehicle.vehicleInfo.collisionCoverage === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Row>
                    <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Choose your “Collision” type.*</Text>
                    <Popover
                      content={
                        <p className={`${AddVehicleStyle["popover"]}`}>
                          {COLLISION_TYPE.map((text, index) => (
                            <p key={index}>{text}</p>
                          ))}
                        </p>
                      }
                      title={null}
                    >
                      <InfoCircleOutlined />
                    </Popover>
                  </Row>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <Select
                      onChange={event => {
                        const vehicleInfo = { ...miVehicle.vehicleInfo }
                        vehicleInfo.collisionType = event
                        setMIVehicle({
                          ...miVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Please make a selection"
                      value={miVehicle.vehicleInfo.collisionType}
                    >
                      {VEHICLE_COLLISION_TYPE.map((item, index) => (
                        <Option key={index} value={item.label}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            )}
            {miVehicle.vehicleInfo.collisionCoverage === 'Yes' && miVehicle.vehicleInfo.collisionType !== 'Limited' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Choose your “Collision” coverage deductible.*</Text>
                <Row className={`${AddVehicleStyle["row-margin-bottom-12"]}`}>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Select
                      onChange={event => {
                        const vehicleInfo = { ...miVehicle.vehicleInfo }
                        vehicleInfo.collisionCoverageDeductible = event
                        setMIVehicle({
                          ...miVehicle,
                          vehicleInfo
                        })
                      }}
                      placeholder="Select from the following"
                      value={miVehicle.vehicleInfo.collisionCoverageDeductible}
                    >
                      {VEHICLE_COLLISION_DEDUCTIBLE.map((item, index) => (
                        <Option key={index} value={item.label}>
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </>
            )}
            {miVehicle.vehicleInfo.otherCollisionCoverage === 'Yes' && (
              <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
                <Col xl={{ span: 6 }} xs={{ span: 24 }}>
                  <Row>
                    <Text className={`${AddVehicleStyle["form-effect-label"]} ${AddVehicleStyle["row-margin-bottom-0"]}`}>Rental Reimbursement*</Text>
                    <Popover content={<p className={`${AddVehicleStyle["popover"]}`}>{RENTAL_REIMBURSEMENT_MI}</p>} title={null}>
                      <InfoCircleOutlined />
                    </Popover>
                  </Row>
                  <Radio.Group
                    onChange={event => {
                      const vehicleInfo = { ...miVehicle.vehicleInfo }
                      vehicleInfo.rentalReimbursement = event.target.value
                      setMIVehicle({
                        ...miVehicle,
                        vehicleInfo
                      })
                    }}
                    value={miVehicle.vehicleInfo.rentalReimbursement}
                  >
                    <Radio value="1">None</Radio>
                    <Radio value="2">$30 per day/ $900 max</Radio>
                    <Radio value="3">$40 per day/ $1,200 max</Radio>
                  </Radio.Group>
                </Col>
              </Row>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is this vehicle primarily kept overnight at the policy address?*</Text>
            <Row className={`${AddVehicleStyle["row-margin-bottom-8"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    const vehicleInfo = { ...miVehicle.vehicleInfo }
                    vehicleInfo.isVehiclePrimarilyKeptOvernight = event.target.value
                    setMIVehicle({
                      ...miVehicle,
                      vehicleInfo
                    })
                  }}
                  value={miVehicle.vehicleInfo.isVehiclePrimarilyKeptOvernight}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {miVehicle.vehicleInfo.isVehiclePrimarilyKeptOvernight === 'No' && (
              <>
                <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Where will the vehicle be kept overnight?*</Text>
                <Row>
                  <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.streetAddress = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Street Address*"
                        value={miVehicle.vehicleInfo.overnightVehicleAddress.streetAddress}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 8, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.apt = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Apartment#"
                        value={miVehicle.vehicleInfo.overnightVehicleAddress.apt}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 5 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.city = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="City*"
                        value={miVehicle.vehicleInfo.overnightVehicleAddress.city}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.state = event.target.value
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="State*"
                        value={miVehicle.vehicleInfo.overnightVehicleAddress.state}
                      />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 5, offset: 1 }} xs={{ span: 24 }}>
                    <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                      <Input
                        autoComplete="off"
                        className={`${AddVehicleStyle["input-text"]}`}
                        maxLength={5}
                        onChange={event => {
                          const vehicleInfo = { ...miVehicle.vehicleInfo }
                          vehicleInfo.overnightVehicleAddress.zipCode = event.target.value.replace(/\D/g, '')
                          setMIVehicle({
                            ...miVehicle,
                            vehicleInfo
                          })
                        }}
                        placeholder="Zip Code*"
                        value={miVehicle.vehicleInfo.overnightVehicleAddress.zipCode}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>Is your vehicle being used for business purposes?*</Text>
            <Row className={`${AddVehicleStyle["row-margin-bottom-12"]}`}>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Radio.Group
                  onChange={event => {
                    setMIVehicle({
                      ...miVehicle,
                      isBusinessPurpose: event.target.value
                    })
                  }}
                  value={miVehicle.isBusinessPurpose}
                >
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Col>
            </Row>
            {miVehicle.isBusinessPurpose === 'Yes' && (
              <Row>
                <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                  <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                    <TextArea
                      autoComplete="off"
                      className={`${AddVehicleStyle["textarea-text"]}`}
                      onChange={event => {
                        setMIVehicle({
                          ...miVehicle,
                          reason: event.target.value
                        })
                      }}
                      placeholder="Please explain why*"
                      rows={4}
                      value={miVehicle.reason}
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            <Text className={`${AddVehicleStyle["form-effect-label"]}`}>What date would you like this change to go into effect?*</Text>
            <Row>
              <Col xl={{ span: 8 }} xs={{ span: 24 }}>
                <Form.Item className={`${AddVehicleStyle["margin-bottom-14"]}`}>
                  <InputMask
                    className={`${AddVehicleStyle["dob"]}`}
                    mask="99/99/9999"
                    onChange={event => {
                      setMIVehicle({
                        ...miVehicle,
                        effectDate: event.target.value
                      })
                    }}
                    placeholder="mm/dd/yyyy*"
                    value={miVehicle.effectDate}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Row>
        <Row className={`${AddVehicleStyle["submit-container"]}`}>
          <Form.Item className={`${AddVehicleStyle["btn-control"]} ${AddVehicleStyle["button-submit-form"]}`}>
            <Space>
              <Button className={`${AddVehicleStyle["register"]} ${AddVehicleStyle["register-form-button"]}`} disabled={validate} onClick={handleSubmit}>
                Submit
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </div>
    </>
  )
}

AddVehicleMI.propTypes = {
  miVehicle: PropTypes.object,
  setMIVehicle: PropTypes.object,
  handleSubmit: PropTypes.object,
  validate: PropTypes.func
}

export default AddVehicleMI
